import { useEffect, useState } from "react";

import { useIntervalTexts } from "pages/[tenant]/browse/hooks/useIntervalTexts";

import { BillboardLoadingContainer, ProgressBar } from "./styles";

interface IBillboardLoadingProps {
  progressRate: number;
}

const texts = [
  "Estamos preparando algo mágico para você...",
  "Seu conteúdo estará pronto em breve...",
  "Carregando seus conteúdos favoritos...",
  "Preparando tudo para você...",
];

export const BillboardLoading = ({ progressRate }: IBillboardLoadingProps) => {
  const [showLoading, setShowLoading] = useState(false);
  const { randomText, startIntervalTexts, stopIntervalTexts } =
    useIntervalTexts({ texts });

  useEffect(() => {
    startIntervalTexts();

    return () => stopIntervalTexts();
  }, []);

  const completeLoaded = progressRate >= 100;
  useEffect(() => {
    if (!completeLoaded) return setShowLoading(true);

    stopIntervalTexts();

    setTimeout(() => {
      setShowLoading(false);
    }, 500);
  }, [completeLoaded]);

  return (
    <BillboardLoadingContainer
      show={showLoading}
      stopTextAnimation={completeLoaded}
      data-is-organization-billboard-loading={showLoading}
    >
      <div className="text-scroller">
        <div className="text">
          {completeLoaded ? "Tudo pronto!" : randomText}
        </div>
      </div>
      <ProgressBar value={progressRate} />
    </BillboardLoadingContainer>
  );
};
